import axios from "axios";
import holidaysGroup from "../../models/gruposDeFeriado/holidaysGroup";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getGroupHolidayId(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/gferiados/${id}`, { headers })
      .then(({ data }) => data);
  }

  getGroupsHolidays() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/gferiados`, { headers }).then(({ data }) =>
      data.map((item) => {
        return holidaysGroup.fromJson(item);
      })
    );
  }

  addGroupHoliday(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
    };

    if (data.feriados && data.feriados.length > 0) {
      payload.feriados = data.feriados;
    }

    if (data.horarios && data.horarios.length > 0) {
      payload.horarios = data.horarios;
    }
    return axios.post(`${url}/gferiados`, payload, { headers });
  }

  deleteGroupHoliday(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/gferiados/${id}`, { headers });
  }

  editGroupHoliday(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
    };

    if (data.feriados && data.feriados.length > 0) {
      payload.feriados = data.feriados;
    }

    if (data.horarios && data.horarios.length > 0) {
      payload.horarios = data.horarios;
    }

    return axios
      .patch(`${url}/gferiados/${data.id}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }
}

export default service;
